import { Fill, Stroke, Style, Text } from "ol/style";
import { getProperty, getPropertyEndingWith } from "./propertyExtraction";
import { roadClassColor, withAlpha } from "./util/hdRoadClass.mjs";

// Road-area view of the LM basemap. Road areas are not ways but 29351 relations
// with a Polygon geometry: `type=lane_group` (a stretch of road) and
// `type=junction_area`. They only reach the viewer because the 38434 gss-wfs lists
// 29351 under its relation ids. The other relations on the same WFS
// (`border_of_lane`, `lane_of_area`) carry no road class and are not drawn.
const ROAD_AREA_TYPES = ["lane_group", "junction_area"];

// The highway class of the RM road the area was built from. `temp` in the key is
// the producer's, not ours; if it gets renamed, follow it here and in
// addfeaturehandlers/laneRoadClass.mjs.
const ROAD_CLASS_KEY = "meta_temp_surface_road_class";

const OUTLINE_COLOR = "#555";
// Junction areas share the fill of their road class; the dashed outline is what
// tells them apart from a lane group.
const JUNCTION_DASH = [6, 4];
// m/px. Labels are hidden when zoomed out further, where they only pile up.
const LABEL_MAX_RESOLUTION = 0.6;
const LABEL_FONT = "12px sans-serif";

export function getRoadAreaStyleNormal(feature, resolution) {
  return getRoadAreaStyle(feature, resolution, 0.35, OUTLINE_COLOR, 1);
}
export function getRoadAreaStyleClick(feature, resolution) {
  return getRoadAreaStyle(feature, resolution, 0.7, "black", 3);
}
export function getRoadAreaStyleHover(feature, resolution) {
  return getRoadAreaStyle(feature, resolution, 0.55, "black", 2);
}

function getRoadAreaStyle(feature, resolution, alpha, outlineColor, width) {
  // Not getProperty: its bare-key lookup would return the top-level
  // `type=ORBIS_RELATION` instead of the relation's own `29351-type`.
  const areaType = getPropertyEndingWith(feature, "-type");
  if (
    feature.get("type") !== "ORBIS_RELATION" ||
    !ROAD_AREA_TYPES.includes(areaType)
  ) {
    return;
  }
  const roadClass = getProperty(feature, ROAD_CLASS_KEY);
  const color = roadClassColor(roadClass);
  return new Style({
    fill: new Fill({ color: withAlpha(color, alpha) }),
    stroke: new Stroke({
      color: outlineColor,
      width: width,
      lineDash: areaType === "junction_area" ? JUNCTION_DASH : undefined,
    }),
    text:
      resolution < LABEL_MAX_RESOLUTION
        ? new Text({
            text: roadClass ?? "?",
            font: LABEL_FONT,
            overflow: true,
            fill: new Fill({ color: "#222" }),
            stroke: new Stroke({ color: "white", width: 3 }),
          })
        : undefined,
  });
}
